import React from 'react';
import { QuickAddressSearchParams } from '../../__generated__/pge-types';
import { Typography, Grid } from '@material-ui/core';
import PGEButton from '../buttons';
import { useTranslation } from '../../hooks/useTranslation';

type Props = {
  address: QuickAddressSearchParams;
  onEdit: () => void;
  onUseEntered: () => void;
};

export default function EnteredArea({ address, onUseEntered, onEdit }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Typography variant="body1">
          {t('YOU_ENTERED')}:{' '}
          <a className="onClickLink" onClick={onEdit}>
            {t('EDIT')}
          </a>
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body1">
          <strong>
            {address.addressLine1}
            <br />
            {address.city} {address.state} {address.postal}
          </strong>
        </Typography>
      </Grid>

      <Grid item>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="body1">
              *{t('ADDRESS_MAY_BE_UNDELIVERABLE')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              {t('ADDRESS_MAY_BE_UNVERIFIED_INFO')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
